<template>
    <!-- FOOTER-4
			============================================= -->
    <footer id="footer-4" class="bg-snow footer division" style="background: #001f3f;">
        <div class="container">


            <!-- FOOTER CONTENT -->
            <div class="row">


                <!-- FOOTER INFO -->
                <div class="col-lg-3">
                    <div class="footer-info mb-40">
                        <img class="footer-logo" :src="settingStore.modalLogo" style="margin-bottom: 20px;">
                        <p class="p-md" style="font-size: 14px;color:white;">
                            We provide you with the Knowledge, the Dispute Flows, the Tools and the Resources to help you achieve the credit scores you desire!
                        </p>
                    </div>
                </div>


                <!-- FOOTER LINKS -->
                <div class="col-sm-6 col-md-3 col-lg-2 col-lg-2 col-xl-2 offset-xl-1">
                    <div class="footer-links mb-40">

                        <!-- Title -->
                        <h6 class="h6-xl" style="color: white;">Company</h6>

                        <!-- Footer Links -->
                        <ul class="foo-links text-secondary clearfix">
                            <li><p class="p-md"><a href="https://www.smartcredit.com/?PID=54821">Get Credit Report</a></p></li>
                            <li><p class="p-md"><a href="#how">How It Works</a></p></li>
                            <li><p class="p-md"><a href="#features">Features</a></p></li>
                            <li><p class="p-md"><a href="#plans">Plans</a></p></li>
                            <li><p class="p-md"><a href="https://affiliates.creditfixrr.com/signup">Affiliate</a></p></li>
                        </ul>
                    </div>
                </div>


                <!-- FOOTER LINKS -->
                <div class="col-sm-6 col-md-3 col-lg-2">
                    <div class="footer-links mb-40">

                        <!-- Title -->
                        <h6 class="h6-xl" style="color: white;">Support</h6>

                        <!-- Footer List -->
                        <ul class="foo-links text-secondary clearfix">
                            <li><p class="p-md"><a href="/privacy">Privacy Policy</a></p></li>
                            <li><p class="p-md"><a href="/termsandconditions">Terms</a></p></li>
                        </ul>

                    </div>
                </div>


                <!-- FOOTER LINKS -->
                <div class="col-sm-6 col-md-3 col-lg-3">
                    <div class="footer-links mb-40">

                        <!-- Title -->
                        <h6 class="h6-xl" style="color: white;">Connect With Us</h6>

                        <!-- Social Links -->
                        <ul class="footer-socials text-secondary ico-25 text-center clearfix">
                            <li><a href="https://www.facebook.com/officialcreditfixrr" style="color: white;"><span class="flaticon-facebook"></span></a></li>
                            <li><a href="https://twitter.com/creditfixrr" style="color: white;"><span class="flaticon-twitter"></span></a></li>
                            <li><a href="https://www.instagram.com/creditfixrr/" style="color: white;"><span class="flaticon-instagram"></span></a></li>
                            <li><a href="https://www.youtube.com/@creditfixrr/" style="color: white;"><span class="flaticon-youtube"></span></a></li>
                        </ul>

                    </div>
                </div>


            </div>	<!-- END FOOTER CONTENT -->


            <hr>


            <!-- BOTTOM FOOTER -->
            <div class="bottom-footer">
                <div class="row row-cols-1 row-cols-md-2 d-flex align-items-center">


                    <!-- FOOTER COPYRIGHT -->
                    <div class="col">
                        <div class="footer-copyright">
                            <p style="color: white;">&copy; 2021 Creditfixrr.com™. All rights reserved.</p>
                        </div>
                    </div>


                    <!-- BOTTOM FOOTER LINKS -->
                    <div class="col">
                        <ul class="bottom-footer-list text-secondary text-end">
                            <li class="first-li"><p><a href="/privacy" style="color: white;">Privacy Policy</a></p></li>
                            <li class="last-li"><p><a href="/termsandconditions" style="color: white;">Terms & Conditions</a></p></li>
                        </ul>
                    </div>


                </div>  <!-- End row -->
            </div>	<!-- BOTTOM FOOTER -->


        </div>
    </footer>	<!-- FOOTER-4 -->
</template>
<script>
    import { useSettingStore } from '../../stores/SettingStore.js'
    export default {
        compomenents:{

        },
        setup(){
            return{
                settingStore:useSettingStore()
            }
        }
    }
</script>
<style>
.foo-links a{
    color:white !important;
}
</style>
